import { gql } from "@apollo/client";
import moment from "moment";

const SAVE_VISITA_OTROS_PROFESIONALES = gql`
  mutation saveVisitaOtrosProfesionales($visitaInput: AddVisitaOtrosProfesionalesInput!, $fechaVisita: CustomDateTime) {
    saveVisitaOtrosProfesionales(visitaInput: $visitaInput, fechaVisita: $fechaVisita) {
      valorEsperado{
        idVisita
      }
      success
      error
    }
  }
`;

export default SAVE_VISITA_OTROS_PROFESIONALES;

export const adaptAddVisitaOtrosProfesionalesInput = (data) => ({
  visitaInput: {
    idVisita: data?.idVisita,
    idEvaluacion: data?.idEvaluacion,
    direccion: data?.direccion,
    posX: data?.posX,
    posY: data?.posY,
    idFrecuencia: data?.idFrecuencia,
    idTipoProfesional: data?.idTipoProfesional,
    idProfesional: data?.idProfesional,
    idComboVisitaValorTipoVisita: data?.idComboVisitaValorTipoVisita,
    idComboVisitaValorInterlocutor: data?.idComboVisitaValorInterlocutor,
    nombreCompleto: data?.nombreCompleto,
    email: data?.email,
    desdeCoordinacion: data?.desdeCoordinacion,
    idFiguraProfesional: data?.idFiguraProfesional
  },
  fechaVisita: data?.fechaVisita
});